import { render, staticRenderFns } from "./message-custom.vue?vue&type=template&id=24995577&scoped=true"
import script from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-custom.vue?vue&type=style&index=0&id=24995577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24995577",
  null
  
)

export default component.exports